module.exports = __webpack_public_path__ + "Frameo-76c483e3.webp";